export const isLink = (link) => {
  if (link?.linktype === 'story') {
    return !!link?.cached_url;
  }

  return link && link.link_type !== 'Any';
};
